import cloudServiceModule from '../cloudService.module';

export default cloudServiceModule.factory('configUiService', [
    '$http',
    '$q',
    configUiService
]);

function configUiService($http, $q) {
    return {
        getSupportContact
    };

    function getSupportContact() {
        var defer = $q.defer();
        $http
            .get(`/assets/config/support-contact.json`)
            .then(
                response => defer.resolve(response.data),
                response => defer.reject(response.data)
            );
        return defer.promise;
    }
}



// WEBPACK FOOTER //
// ./modules/cloudService/config/configUi.service.js